import { lazy } from "react";

// Clinical Notes Audit — agenda del día (scheduler V2 de AdvancedMD) → nota
// clínica completa de la visita seleccionada (GET by-visit).
// Guía: docs/modulos/Auditor/GUIA-FRONT-Modulo-Citas-y-NotasPorVisita.md
//
// ACCESO (piloto 2026-10-14, ampliado 2026-10-20): lo decide
// ROUTE_ALLOWED_EMPLOYEE_IDS en roleRoutePermissions.js — entran los empleados
// 68, 89, 90, 74 y 80, más admin/CEO por adminBypass. La key pendiente
// `clinical_notes_audit` queda de respaldo hasta que backend cree el módulo en
// TAB_MODULES y la matriz RBAC decida quién entra.
const ClinicalNotesAuditPage = lazy(() => import("./pages/ClinicalNotesAuditPage"));
const VisitAuditPage = lazy(() => import("./pages/VisitAuditPage"));

export const clinicalNotesAuditRoutes = [
  { path: "/clinical-notes-audit", element: <ClinicalNotesAuditPage /> },
  // Detalle de la visita: cita + paciente + nota clínica + botón Audit. Hereda
  // el gate RBAC por prefijo (/clinical-notes-audit gana para las subrutas).
  { path: "/clinical-notes-audit/visit/:visitId", element: <VisitAuditPage /> },
];
